import styled from "@emotion/styled";

import { Container as LeftBalloonContainer } from "./left-balloons/styles";
import { Container as RightBalloonContainer } from "./right-balloons/styles";

export const Container = styled.div`
  display: none;

  ${props => props.theme.breakpoints.up("desktop")} {
    position: absolute;

    display: flex;
    justify-content: space-between;

    inline-size: 1120px;
    block-size: 100%;

    ${LeftBalloonContainer} {
      position: relative;
      inset-block-start: 380px;
      inset-inline-start: 0;
    }

    ${RightBalloonContainer} {
      position: relative;
      inset-block-start: 316px;
      inset-inline-start: 0;
    }
  }
`;
